import styled from '@emotion/styled';
import { ReactNode } from 'react';
import * as React from 'react';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverHighlight, hoverOpacity } from '@/utility/theme/animation';

type ButtonProps = {
  children: ReactNode;
  size:
    | keyof typeof defaultTheme.font.size
    | (keyof typeof defaultTheme.font.size)[];
  color?: keyof typeof defaultTheme.text;
  fontWeight?: string;
  type?: 'button' | 'reset' | 'submit' | undefined;
  hoverEffect?: 'default' | 'highlight';
  onClick?: () => void;
};

const hoverEffectCss = (effectType?: 'default' | 'highlight') => {
  switch (effectType) {
    case 'default': {
      return hoverOpacity;
    }
    case 'highlight': {
      return hoverHighlight;
    }
    default: {
      return {};
    }
  }
};

const StyledButton = styled.button((props: ButtonProps) =>
  mq({
    ...hoverEffectCss(props.hoverEffect),
    color: props.color
      ? defaultTheme.text[props.color]
      : defaultTheme.text.default,
    fontSize: Array.isArray(props.size)
      ? props.size.map(s => defaultTheme.font.size[s])
      : defaultTheme.font.size[props.size],
    fontWeight: props.fontWeight ? props.fontWeight : 'inherit',
    textAlign: 'center',
    border: 'none',
    borderRadius: defaultTheme.border.radius.s,
    cursor: 'pointer',
    transition: 'all .2s ease-out',
  }),
);

const TextButton: React.FC<ButtonProps> = props => {
  const { children, size, type, hoverEffect = 'default', onClick } = props;

  return (
    <StyledButton
      size={size}
      type={type}
      hoverEffect={hoverEffect}
      onClick={onClick}
    >
      {children}
    </StyledButton>
  );
};

export default TextButton;
